import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './Craps.css';
import { useTokens } from '../components/TokenContext';

function Craps() {
    const [bet, setBet] = useState('');
    const [dice1, setDice1] = useState(null);
    const [dice2, setDice2] = useState(null);
    const [result, setResult] = useState('');
    const { fetchTokens } = useTokens();

    const handleStartGame = async () => {
        setDice1(null);
        setDice2(null);
        const userId = localStorage.getItem('fw_user');

        if (!userId) {
            Swal.fire('Chyba', 'Uživatel není přihlášen.', 'error');
            return;
        }

        if (!bet || bet <= 0) {
            Swal.fire('Chyba', 'Zadejte platnou sázku.', 'warning');
            return;
        }

        try {
            const response = await fetch('https://api.fantasyworldtrpg.cz/casino-api/craps.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    user_id: userId,
                    bet: bet
                })
            });

            const data = await response.json();

            if (data.error) {
                Swal.fire('Chyba', data.error, 'error');
                return;
            }

            setDice1(data.dice1);
            setDice2(data.dice2);

            if (data.win) {
                Swal.fire('Výhra!', `Vyhrál jsi ${data.payout.toLocaleString('cs-CZ')} Coinů! 🎉`, 'success');
            }
            /*else {
                Swal.fire('Prohra', 'Bohužel jsi prohrál, zkus to znovu! 😢', 'error');
            }*/

            setResult(`Součet: ${data.total}`);
            fetchTokens();
        } catch (error) {
            Swal.fire('Chyba', 'Nepodařilo se spojit se serverem.', 'error');
        }
    };

    return (
        <div className="game-craps">
            <h1>Kostky 🎲</h1>
            <p>Pravidla: Vyhráváš, pokud hodíš 7 nebo 11. Pokud hodíš cokoliv jiného, prohráváš.</p>

            <div className="input-container">
                <input
                    type="number"
                    min="2"
                    value={bet}
                    onChange={(e) => setBet(e.target.value)}
                    placeholder="Zadej sázku"
                    className="form-control"
                />
                <button className="btn btn-success" onClick={handleStartGame}>Start</button>
            </div>

            {dice1 && dice2 && (
                <div className="dice-animation">
                    <div className="dice">{dice1}</div>
                    <div className="dice">{dice2}</div>
                </div>
            )}

            {result && <p className="result">{result}</p>}
        </div>
    );
}

export default Craps;
